/* eslint-disable no-param-reassign */
export default (state, { payload }) => {
  Object.entries(payload)
    .filter(([, value]) => value !== undefined)
    .forEach(([key, value]) => {
      state[key] = state[key] ?? value;
    });
};
